function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

import React from 'react';
import { verifyFieldValue } from './utils';
import { PropTypes } from 'mobx-react';
import { toJS } from 'mobx';
import classnames from 'classnames';
import './style/index.css';
import { isVoidValue } from './utils';
/**
 * 表单控件扩展方法
 */

var componentMethods = {
  /**
   * 控件获取焦点回调
   * @param {*} e 
   */
  focusHandler: function focusHandler(e) {
    if (typeof this.props.onFoucs === "function") {
      this.props.onFoucs(e);
    } // this.verify("focus");

  },

  /**
   * 控件失去焦点回调
   * @param {*} e 
   */
  blurHandler: function blurHandler(e) {
    if (typeof this.props.onBlur === "function") {
      this.props.onBlur(e);
    } // this.verify("blur");

  },

  /**
   * shouldComponentUpdate 生命周期函数 
   * @param {*} nextProps 
   * @param {*} nextState 
   */
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (this.props.defaultValue !== nextProps.defaultValue) {
      return true;
    }

    var needUpdate = this.attrs.$sui.compareProps(this.props, this.state, nextProps, nextState);

    if (typeof this.shouldComponentUpdateFilter === "function") {
      needUpdate = this.shouldComponentUpdateFilter(needUpdate, nextProps, nextState);
    }

    if (needUpdate) {
      this.verify(nextState && nextState.verify || "update");
    }

    needUpdate && console.info('form component should update -> ', needUpdate, this);
    return !!needUpdate;
  },

  /**
   * componentWillReceiveProps
   * @param {*} props 
   * @param {*} context 
   */
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(props, context) {
    if (typeof this.componentWillReceivePropsAction === "function") {
      this.componentWillReceivePropsAction(props, context);
    }

    this.attrs.$sui.attach(props, this, context, 'receiveProps');
  },

  /**
   * 统一检验函数
   * @param {*} trigger 
   */
  verify: function verify() {
    var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var value = this.getValue();

    if (value === null) {
      value = "";
    }

    var defaultResult = {
      value: value
    };

    if (this.verifyResult && this.verifyResult.value !== undefined && this.verifyResult.value === value && trigger !== true) {
      // 值未变化不重复检验
      console.log('do not verify at same value', this.props.name, trigger);
      return this.verifyResult || defaultResult;
    } // 触发所表单的value change


    if (trigger === 'change' && this.context && this.context.mobxStores && this.context.mobxStores.form) {
      this.context.mobxStores.form.onChangeValue && this.context.mobxStores.form.onChangeValue(this.props.name, value);
    } // 禁用检验的条件


    if (this.attrs.disabled || this.attrs.readOnly) {
      // readonly disabled 禁用检验
      return this.verifyResult = defaultResult;
    } // 跳过检验条件


    if (typeof this.beforeVerify === "function") {
      var result = this.beforeVerify(trigger);

      if (result === false || _typeof(result) === 'object') {
        this.verifyResult = result ? result : defaultResult;
        result && this.forceUpdate();

        if (trigger !== true || result) {
          return this.verifyResult;
        }
      }
    }

    if (this.props.verifyTriggers === false && trigger !== true) {
      return this.verifyResult = defaultResult;
    } // 检验触发条件


    var triggers = Object.assign({
      init: false,
      change: true,
      update: false,
      focus: false,
      blur: true,
      input: true
    }, this.props.verifyTriggers || {});

    if (trigger && typeof trigger === "string" && !triggers[trigger]) {
      return this.verifyResult || defaultResult;
    }

    console.log('verify -> ', this.props.name, trigger);
    var _this$props = this.props,
        _this$props$rules = _this$props.rules,
        rules = _this$props$rules === void 0 ? [] : _this$props$rules,
        format = _this$props.format;
    var errorTip = this.props.tip || '';
    rules = rules.slice();

    if (this.props.required) {
      rules.push({
        type: "required",
        msg: this.defaultRuleMsgs && this.defaultRuleMsgs.required
      });
    }

    if (typeof value === "string" && !value.length && !hasRequiredRule(rules)) {
      this.verifyResult = defaultResult;
      typeof trigger === "boolean" && this.forceUpdate();
      return this.verifyResult;
    }

    if (this.props.max && !this.props.range) {
      rules.push({
        type: "max",
        value: 1 * this.props.max,
        msg: this.defaultRuleMsgs && this.defaultRuleMsgs.max
      });
    }

    if (this.props.min && !this.props.range) {
      rules.push({
        type: "min",
        value: 1 * this.props.min,
        msg: this.defaultRuleMsgs && this.defaultRuleMsgs.min
      });
    }

    if (this.props.maxLength) {
      rules.push({
        type: "maxLength",
        value: 1 * this.props.maxLength,
        msg: this.defaultRuleMsgs && this.defaultRuleMsgs.maxLength
      });
    }

    if (this.props.minLength) {
      rules.push({
        type: "minLength",
        value: 1 * this.props.minLength,
        msg: this.defaultRuleMsgs && this.defaultRuleMsgs.minLength
      });
    }

    this.verifyResult = verifyFieldValue(value, rules, format, errorTip, this.verifyRuleFilter);

    if (typeof this.props.onVerify === "function") {
      this.props.onVerify(this.verifyResult, trigger);
    }

    typeof trigger === "boolean" && this.forceUpdate();
    return this.verifyResult;
  },

  /**
   * 默认提示方法
   * @param {*} msg 
   */
  getDefaultErrorMsg: function getDefaultErrorMsg(msg) {
    return /*#__PURE__*/React.createElement("div", {
      className: "ant-form-explain"
    }, msg);
  },

  /**
   * getvalue
   */
  getValue: function getValue() {
    var value = toJS(this.attrs.value);
    return value;
  },

  /**
   * setvalue
   * @param {*} value 
   */
  setValue: function setValue(value) {
    this.attrs.value = value;
    return this;
  },

  /**
   * 重置
   */
  reset: function reset(force) {
    var mapings = this.attrs.$sui.mapings;

    if (!force && (mapings && mapings.hasOwnProperty('value') || typeof this.props.value !== 'undefined')) {
      return;
    }

    this.attrs.value = this.props.hasOwnProperty('defaultValue') ? this.props.defaultValue : typeof this['defaultValue'] == 'undefined' ? undefined : this['defaultValue']; // this.forceUpdate();
  },

  /**
   * 设置禁用
   * @param {*} disabled 
   */
  setDisabled: function setDisabled(disabled) {
    this.attrs.disabled = disabled !== false ? true : false;
  },

  /**
   * 设置只读
   * @param {*} readOnly 
   */
  setReadonly: function setReadonly(readOnly) {
    this.attrs.disabled = readOnly !== false ? true : false;
  }
};
/**
 * 控件勾子扩展方法
 */

var componentFilters = {
  componentDidMount: function componentDidMount() {
    this._componentDidMount && this._componentDidMount.apply(this);
    this.mounted = true;
  },
  componentWillUnmount: function componentWillUnmount() {
    this._componentWillUnmount && this._componentWillUnmount.apply(this);
    this.mounted = false;
  },
  UNSAFE_componentWillUnmount: function UNSAFE_componentWillUnmount() {
    this._UNSAFE_componentWillUnmount && this._UNSAFE_componentWillUnmount.apply(this);
    this.mounted = false;
  }
};
/**
 * 判断是否存在必填规则
 */

export function hasRequiredRule(rules) {
  return hasRuleType(rules, 'required');
}
/**
 * 判断是否存在某个规则
 */

export function hasRuleType(rules, type) {
  var hasRule = false;

  if (rules && rules.length) {
    for (var index = 0; index < rules.length; index++) {
      var rule = rules[index];

      if (typeof rule === "string" && rule === type || _typeof(rule) === "object" && rule.hasOwnProperty('type') && rule.type === type) {
        hasRule = true;
        break;
      }
    }
  }

  return hasRule;
}
/**
 * create表单控件
 * @param {*} Component 
 */

function createFormComponent(Component) {
  for (var key in componentMethods) {
    if (componentMethods.hasOwnProperty(key) && !Component.prototype[key]) {
      Component.prototype[key] = componentMethods[key];
    }
  }

  for (var _key in componentFilters) {
    if (componentFilters.hasOwnProperty(_key)) {
      if (Component.prototype[_key]) {
        Component.prototype['_' + _key] = Component.prototype[_key];
      }

      Component.prototype[_key] = componentFilters[_key];
    }
  }

  var render = Component.prototype.render;

  Component.prototype.render = function () {
    var _this$attrs = this.attrs,
        readOnly = _this$attrs.readOnly,
        disabled = _this$attrs.disabled;
    var mode;

    if (this.context && this.context.mobxStores && this.context.mobxStores) {
      mode = this.context.mobxStores.formMode;
    }

    var hasError = !!(this.verifyResult && this.verifyResult.hasError);
    var hasSuccess = !!(this.verifyResult && this.verifyResult.hasSuccess);
    var cls = classnames('sui-formcomponent', _defineProperty({
      'sui-formcomponent-readonly': readOnly,
      'sui-formcomponent-disabled': disabled,
      'sui-formcomponent-error': hasError,
      'sui-formcomponent-with-explain': !!this.props.help || hasError,
      'sui-formcomponent-required': !!this.props.required,
      'has-error': hasError,
      'has-success': !hasError && hasSuccess,
      'ant-form-item-has-error': hasError,
      'ant-form-item-has-success': !hasError && hasSuccess,
      'ant-form-item-with-help': !!this.props.help || hasError
    }, "sui-formcomponent-mode-".concat(mode), !!mode));
    var rendered = render.apply(this, arguments);
    var msg;

    if (this.props.help) {
      msg = this.getDefaultErrorMsg(this.props.help);
    }

    if (hasError && !this.props.hideDefaultErrorMsg) {
      msg = /*#__PURE__*/React.createElement("div", {
        className: "ant-form-item-explain-error"
      }, this.getDefaultErrorMsg(this.verifyResult.errorMsg));
    }

    if (Component.formWrapper === false) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, rendered, msg);
    }

    return /*#__PURE__*/React.createElement("span", {
      className: cls
    }, rendered, msg);
  }; // 上下文


  Component.contextTypes = Component.contextTypes || {};
  Component.contextTypes.mobxStores = PropTypes.objectOrObservableObject;
  return Component;
}

export default createFormComponent;